import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../user.css';
import { Image } from '@/components/Elements';
// import house from '@/assets/house.png';
import icon1 from '@/assets/icon1.png';
import icon2 from '@/assets/icon2.png';
import icon3 from '@/assets/icon3.png';
// import pay1 from '@/assets/pay1.png';
import { PropertyforRent } from '@/types';
import { changeFav } from '@/api/propertyForRent/changeFav';
import FileViewer from '@/components/Viewer/FileViewer';
import { deletePropertyItem } from '@/api/deletePropertyItem';
import plus from '@/assets/plus.png';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { Button } from '@/components/Elements/Button';
import { useNotificationStore } from '@/stores/notifications';
// import FileViewer from '@/components/Viewer/FileViewer';
import { changeAllFav } from '@/api/changeAllFav';
import { useAuth } from '@/lib/auth';
import { formatPrice, trimSixty } from '@/utils/format';
import storage from '@/utils/storage';
import i18next from 'i18next';
import { FeatureAdd } from './FeatureAddDialog';
import { upperFirst } from 'lodash';

const PropertyForRentItem = ({
  item,
  headData,
  editIcon,
  deleteIcon,
  heartIcon,
  heartFavIcon,
  setHeartClicked,
  setDeleteClicked,
  has_subscription,
}: {
  deleteIcon: boolean;
  item: PropertyforRent;
  headData: boolean;
  editIcon: boolean;
  heartFavIcon: boolean;
  heartIcon: boolean;
  setHeartClicked: any;
  setDeleteClicked: any;
  has_subscription: boolean;
}) => {
  const navigate = useNavigate();
  const localSymbol = storage.getSymbol();
  const localAmount = storage.getAmount();

  const [showFeatureAdd, setShowFeatureAdd] = useState(false);

  const handleNavigate = () => {
    navigate(`/property-for-rent-detail/${item.id}?type=RentProperty`);
  };
  const [favIcon, setFavIcon] = useState<boolean>(!!item.is_favourite);
  const [open, setOpen] = useState(false);

  // const onOpenModal = () => setOpen(true);
  const { user } = useAuth();
  const onOpenModals = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setOpen(true);
  };

  const onCloseModal = () => setOpen(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const deleleItems = async (id: string, types: string) => {
    try {
      setButtonLoading(true);
      await deletePropertyItem(id, types);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Item deleted successfully!',
      });
    } finally {
      setDeleteClicked(true);
      setOpen(false);
      setButtonLoading(false);
    }
  };
  const typeVal = 'RentProperty';

  const deleleItemsSelect = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    deleleItems(item.id, typeVal);
  };
  const changeUnfavStatusAction = async (id: string, type: string) => {
    try {
      const data: any = await changeAllFav(id, type);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: upperFirst(data?.message),
      });
    } finally {
      setHeartClicked(true);
    }
  };
  const handleUnfavourite = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeUnfavStatusAction(item.id, item.type);
    // refetch();
  };

  const changeStatusAction = async (id: string, accept: boolean) => {
    try {
      if (user) {
        await changeFav(id, accept);
        setHeartClicked(true);
      } else {
        useNotificationStore.getState().addNotification({
          title: 'Warning',
          type: 'info',
          message: 'Please Login first!',
        });
        navigate('/auth/login');
      }
    } finally {
    }
  };
  const handleClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setFavIcon((val) => !val);
    changeStatusAction(item.id, false);
  };
  const handleClick2 = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeStatusAction(item.id, true);
    setFavIcon((val) => !val);
  };
  const handleEdit = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    // navigate(`/user/add-property-for-rent/${item.id}?type=RentProperty`);
    navigate(`/user/add-property-for-rent?id=${item.id}&type=RentProperty`);
  };

  const [photo, setPhoto] = useState<any>();
  const [pics, setPics] = useState<any>();
  const [img1, setImg1] = useState();

  useEffect(() => {
    if (item?.image_data) {
      const parsed_data = item?.image_data;
      setImg1(parsed_data[0]);
    }
  }, [item?.image_data]);

  // useEffect(() => {
  //   try {
  //     const evaluatedData = eval(item?.image_data);
  //     setPics(evaluatedData);

  //     if (item?.image_data?.length === 0) {
  //       return;
  //     }

  //     if (pics) {
  //       setPhoto(pics[0]?.image);
  //     }
  //   } catch (error) {
  //     console.error('Error evaluating image_data:', error);
  //   }
  // }, [item.image_data, pics]);

  function convertToInternationalCurrencySystem(labelValue: string) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(0) + 'B'
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(0) + 'M'
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(0) + 'K'
      : Math.abs(Number(labelValue));
  }

  return (
    <>
      <div className="col-12 col-md-6 col-lg-3 home-prop-col">
        <button className="w-full" onClick={handleNavigate}>
          <div className="item-box deals-page p-2 position-relative">
            <div>
              {/* <div className="head-functions2 ">
                <i className="fa-regular fa-heart"></i>
              </div> */}
              {headData == true ? (
                <>
                  <div className="head-functions">
                    <span className="status">{i18next.t('Property For Rent')}</span>
                    <div className="d-flex icons">
                      {editIcon == true ? (
                        <span>
                          <button onClick={handleEdit}>
                            <i className="fa-solid fa-pen" />
                          </button>
                        </span>
                      ) : null}
                      {deleteIcon == true ? (
                        <span>
                          <button onClick={onOpenModals}>
                            <i className="fa-solid fa-trash" />
                          </button>
                        </span>
                      ) : null}
                      {heartIcon == true ? (
                        <div className=" fav-lists">
                          {favIcon ? (
                            <button onClick={handleClick}>
                              <i className="fa-solid fa-heart"></i>
                            </button>
                          ) : (
                            <button onClick={handleClick2}>
                              <i className="fa-regular fa-heart"></i>
                            </button>
                          )}
                        </div>
                      ) : null}
                      {heartFavIcon == true ? (
                        <div className=" fav-lists">
                          <button onClick={handleUnfavourite}>
                            <i className="fa-solid fa-heart"></i>
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="head-functions3">
                    <span
                      className={`status ${
                        item?.status == 'Approved'
                          ? 'approved'
                          : item?.status == 'Pending'
                          ? 'pending'
                          : 'disapprove'
                      }`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item?.status}
                    </span>

                    {(has_subscription && item?.status === 'Approved') || item?.is_ad_featured ? (
                      <span className="feature" onClick={(e) => e.stopPropagation()}>
                        Featured
                      </span>
                    ) : (
                      !has_subscription &&
                      !item?.is_ad_featured &&
                      item?.status === 'Approved' && (
                        <span
                          className="status"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowFeatureAdd(true);
                          }}
                        >
                          Add Feature
                        </span>
                      )
                    )}
                  </div>
                </>
              ) : (
                <div className="head-functions2 ">
                  {item.is_favourite == true ? (
                    <button onClick={handleClick}>
                      <i className="fa-solid fa-heart"></i>
                    </button>
                  ) : (
                    <button onClick={handleClick2}>
                      <i className="fa-regular fa-heart"></i>
                    </button>
                  )}
                </div>
              )}
              {/* {item?.image_data?.length == 0 ? (
                <FileViewer file={plus ?? ''}></FileViewer>
              ) : (
                <Image
                  // imagefallback={eval(item?.image_data)[0]?.image}
                  className="itemImage"
                  alt="banner"
                  src={photo ?? item?.image_data}
                />
              )} */}

              {item?.image_data ? (
                <>
                  {item?.image_data.length == 0 ? (
                    <FileViewer file={plus ?? ''}></FileViewer>
                  ) : (
                    <div className="res-slider-icon">
                    <Image
                      // imagefallback={eval(item?.image_data)[0]?.image}
                      className="itemImage"
                      alt="banner"
                      src={img1 ?? ''}
                    />
                    </div>
                  )}
                </>
              ) : null}

              {/* {item?.image_data !== '' ? (
                <Image className="itemImage" alt="banner" src={item?.image_data ?? ''} />
              ) : (
                <Image className="itemImage" alt="banner" src={''} />
              )} */}

              {/* <FileViewer file={photo ?? ''}></FileViewer> */}

              <div className="sale-div">
                <div className="col-md-12 col-12">
                  <h6 className="text-dark mt-2 mb-0">{item.title}</h6>
                  <p className="text-sm left-kar  mb-1">
                    {/* {localSymbol} {formatPrice(item?.monthly_rent * localAmount)}
                     */}
                     {localSymbol} {formatPrice(item?.monthly_rent)}
                    
                  </p>
                  <p className="text-sm stx left-kar mb-2"><i className="fa-solid fa-map-location-dot"></i>{trimSixty(item?.location)}</p>
                </div>
                {/* <div className="col-md-4 col-4 photoo">
                  <img src={pay1} alt="pay1" />
                </div> */}
              </div>

              <div className="bottom-beds align-items-center d-flex gap-2 flex-wrap">
                <div className="w-max thy">
                  <img className="spic" src={icon1} alt="pay1" />{' '}
                  <span className='semi-bold'>
                    {item.bathrooms} {i18next.t('Baths')}
                  </span>
                </div>
                <div className="w-max thy">
                  <img className="spic" src={icon2} alt="pay1" />{' '}
                  <span  className='semi-bold'>
                    {item.bedrooms} {i18next.t('Beds')}
                  </span>
                </div>
                <div className="w-max thy">
                  <img className="spic" src={icon3} alt="pay1" />{' '}
                  <span  className='semi-bold'>
                    {item.use_area}
                    {i18next.t('sqFt')}{' '}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </button>
        <Modal open={open} onClose={onCloseModal} center>
          <section className="model-datas text-center">
            <h3>Are you sure you want to delete this item ?</h3>
          </section>
          <p className="btn-lines delete-bots d-flex justify-content-center">
            <Button isLoading={buttonLoading} onClick={deleleItemsSelect}>
              {i18next.t('Yes')}
            </Button>
            <Button onClick={onCloseModal}>{i18next.t('No')}</Button>
          </p>
        </Modal>

        <FeatureAdd
          propType="rent_property"
          propId={item.id}
          show={showFeatureAdd}
          setShow={setShowFeatureAdd}
        />
      </div>
    </>
  );
};

export default PropertyForRentItem;
